import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { CorrectionsModal, FullTable, ToastScreen } from 'components';
import {
  ACTION_TYPE_PENDING_PAYABLES_BATCHES_DETAILS, approvedPayableBatchesDetailsBody, approvedPayableBatchesDetailsHead,
  SEND_CORRECTION,
} from './constants';
import { LoadDetailSwitcher } from '../../loads';
import {
  httpRequestsOnErrorsActions,
  httpRequestsOnLoadActions,
  httpRequestsOnSuccessActions,
  loadActions,
  LoadServices,
} from 'store';
import { FindError, FindSuccess, useModal, usePrimaryModal } from 'utils';
import { PayableNotes } from './payableNotes';

export const ApprovedPayableBatchesDetails = ({ batch, getBatches, getTotals, onListInfoChange }) => {
  const [correction, setCorrection] = useState('');
  const dispatch = useDispatch();
  const { loadsPayableBatches } = useSelector((state) => ({
    loadsPayableBatches: state.loads.loadsPayableBatches,
  }));
  const beckErrorSendCorrection = FindError(SEND_CORRECTION);
  const successCreatePayableNote = FindSuccess('CREATE_PAYABLE_NOTE');
  const successEditPayableNote = FindSuccess('EDIT_PAYABLE_NOTE');
  const successDeletePayableNote = FindSuccess('DELETE_PAYABLE_NOTE');
  const { open, close } = useModal();
  const { openPrimary, closePrimary } = usePrimaryModal();


  useEffect(() => {
    if (beckErrorSendCorrection?.[0]?.error) {
      dispatch(httpRequestsOnErrorsActions.removeError(SEND_CORRECTION));

      toast(
        <ToastScreen
          type={'error'}
          text={'This action isn’t available right now for this load.'}
        />,
      );
    }

  }, [beckErrorSendCorrection?.[0]?.error]);


  useEffect(() => {
    if (successCreatePayableNote?.length || successEditPayableNote?.length || successDeletePayableNote?.length) {

      if (successCreatePayableNote?.length) {
        dispatch(httpRequestsOnSuccessActions.removeSuccess('CREATE_PAYABLE_NOTE'));
      }

      if (successEditPayableNote?.length) {
        dispatch(httpRequestsOnSuccessActions.removeSuccess('EDIT_PAYABLE_NOTE'));
      }

      if (successDeletePayableNote?.length) {
        dispatch(httpRequestsOnSuccessActions.removeSuccess('DELETE_PAYABLE_NOTE'));
      }

      if (batch?.id) {
        dispatch(loadActions.getLoadsPayableBatches(batch?.id, false));
      }
      close();
    }
  }, [successCreatePayableNote, successEditPayableNote, successDeletePayableNote]);

  useEffect(() => {
    if (batch?.id) {
      dispatch(loadActions.getLoadsPayableBatches(batch?.id));
    }
  }, [batch?.id]);


  const handleClick = (item) => {
    openPrimary(
      <CorrectionsModal
        handleChangeText={(value) => setCorrection(value)}
        actionType={SEND_CORRECTION}
        handleSend={() => handleSend(item?.id)}
        type={'notVerified'}
        handleClose={closePrimary}
      />);
  };

  const handleAddNote = (item) => {
    open(
      <PayableNotes
        load={item}
        afterSuccess={() => {
          close();
          if (batch?.id) {
            dispatch(loadActions.getLoadsPayableBatches(batch?.id, false));
          }
        }}
      />,
      { noPadding: true, noCloseButton: true },
    );
  };

  const handleSend = async (id) => {
    dispatch(httpRequestsOnLoadActions.appendLoading(SEND_CORRECTION));
    dispatch(httpRequestsOnErrorsActions.removeError(SEND_CORRECTION));
    try {
      const date = { 'correction': correction };
      await LoadServices.PayableCorrections(id, date);
      dispatch(loadActions.getLoadsPayableBatches(batch?.id));
      closePrimary();
      getBatches();
      getTotals();
    } catch (e) {
      dispatch(httpRequestsOnErrorsActions.appendError(SEND_CORRECTION, e?.data?.message));
    } finally {
      dispatch(httpRequestsOnLoadActions.removeLoading(SEND_CORRECTION));
    }
  };

  return (
    <div style={{ padding: '10px', background: '#E6ECF3' }}>
      <FullTable
        head={approvedPayableBatchesDetailsHead()}
        body={
          approvedPayableBatchesDetailsBody({
            clickRequestCorrection: handleClick,
            handleAddNote,
          })}
        loadingType={ACTION_TYPE_PENDING_PAYABLES_BATCHES_DETAILS}
        onListInfoChange={onListInfoChange}
        list={loadsPayableBatches}
        fixHeight='45vh'
        margin={'0px'}
        handleClick={(id) =>
          openPrimary(<LoadDetailSwitcher loadId={id} />)
        }
        noText={'Approved Payable Batches'}
        padding={'8px'}
        paddingHead={'8px'}
      />
    </div>
  );
};

